import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/modules/user";
import requestPreparing from "@/store/modules/requestPreparing";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    requestPreparing,
  },
});
